import React from 'react'

import { Banner } from '@sendoutcards/quantum-design-ui'
import { getMarketingBanners } from 'src/graphql'
import { useQueries } from 'src/hooks'
import { DefaultError, SuspenseBoundary } from 'src/chrome'

const styles = {
  innerBanner: {
    maxHeight: '150px',
    overflow: 'auto',
    p: {
      fontSize: '0.875rem',
    },
  },
}

interface IAnnouncementBannersProps {}

const AnnouncementBanners: React.FC<IAnnouncementBannersProps> = () => {
  return (
    <SuspenseBoundary unresolved={false} failure={DefaultError}>
      <GenerateBannerComponents />
    </SuspenseBoundary>
  )
}

const GenerateBannerComponents: React.FC = () => {
  const [banners] = useQueries(getMarketingBanners())

  if (!banners || banners.length === 0) {
    return null
  }

  return (
    <div
      style={{
        marginTop: '10px',
        marginBottom: '10px',
        paddingLeft: '1em',
        paddingRight: '1em',
      }}
    >
      {banners.map((banner, idx) => (
        <div
          style={{ paddingTop: idx === 0 ? '0px' : '10px' }}
          key={banner.title}
        >
          <Banner status={'success'} icon={'exclamation'}>
            {
              <div
                css={styles.innerBanner}
                dangerouslySetInnerHTML={{ __html: banner.htmlContent }}
              />
            }
          </Banner>
        </div>
      ))}
    </div>
  )
}

export default AnnouncementBanners
